// reducers/door/save.js

export function saveHasErrored(state = false, action) {
  switch (action.type) {
    case 'SAVE_DOOR_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function saveIsLoading(state = false, action) {
  switch (action.type) {
    case 'SAVE_DOOR_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function save(state = {}, action) {
  switch (action.type) {
    case 'SAVE_DOOR_FETCH_DATA_SUCCESS':
      return action.resp;
    default:
      return state;
  }
}